import ToolImg from './img/tool.png';
import React from 'react';

const Tool = () => {
    return <img
                src={ToolImg}
                alt="tool"
                width={50}
            />;
}

export default Tool;